import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AxisType } from 'src/app/components/util/constants/AxisType';
import { Message } from 'src/app/models/message';
import { Axis } from 'src/app/models/survey/axis';
import { AxisService } from 'src/app/services/survey/axis.service';

@Component({
  selector: 'app-svaxis-list',
  templateUrl: './svaxis-list.component.html',
  styleUrls: ['./svaxis-list.component.scss']
})
export class SvaxisListComponent implements OnInit {

  svaxis: Axis[] = [];
  msg: Message = { status: null, message: null };
  hiddenMsg: boolean = true;
  idoptionSelected: string = null;
  axisTypes: AxisType[] = [
    { id: 1, name: 'Fila' },
    { id: 2, name: 'Columna' },
    { id: 3, name: 'Dimensión' },
  ];

  constructor(
    private axisS: AxisService,
    private activedRoute: ActivatedRoute,
  ) { }

  ngOnInit() {
    const params = this.activedRoute.snapshot.params;
    this.idoptionSelected = params['idoption'];
    this.get4OptionAdm(params['idoption']);
  }

  get4OptionAdm(id: string) {
    this.axisS.get4OptionAdm(id).subscribe(
      res => {
        this.svaxis = res['data'];
        this.namedOptions(this.svaxis);

      },
      err => { this.msg = err; }
    );
  }

  namedOptions(svaxis: Axis[]) {
    if (svaxis) {
      svaxis.forEach(a => {
        this.axisTypes.forEach(at => {
          if (a.type == at.id) {
            a.nameType = at.name;
          }
        });
      });
    }

  }

  remove2(id: string) {
    this.axisS.delete(id).subscribe(
      res => {
        this.msg.message = res['message'];
        this.msg.status = res['status'];
        this.hiddenMsg = false;
        this.get4OptionAdm(this.idoptionSelected);
      },
      err => {
        this.msg.message = err["error"].message;
        this.msg.status = err["error"].status;
      }
    );
  }

  remove(id: string) {
    if (confirm('¿Está seguro que desea eliminar el registro?')) {
      this.axisS.delete(id).subscribe(
        res => {
          this.msg.message = res['message'];
          this.msg.status = res['status'];
          this.hiddenMsg = false;
          this.get4OptionAdm(this.idoptionSelected);
        },
        err => {
          this.msg.message = err["error"].message;
          this.msg.status = err["error"].status;
        }
      );

    }
  }

}

